import * as Sentry from '@sentry/react';
import { NotificationManager } from 'react-notifications';
import _ from 'lodash';

type Translate = (key: string, fallback?: string, options?: Record<string, unknown>) => string;

/**
 * Report a failed comment write. Shared by the modal and the individual message row so both
 * surfaces say the same thing — the server's own error key when it sent one, the generic fallback
 * otherwise. Both keys already exist in Lokalise under shared::conversationModal.
 *
 * Only the axios interceptor's own cases (401, 403, 415, network) reach the user on their own; a
 * 404 for an entry someone else deleted, and any 5xx, arrive here with nothing else to show them.
 */
export function reportConversationError(t: Translate, error: unknown) {
  const message = _.get(
    error,
    'response.data.error',
    t('notification.error.unexpected.description', 'Oväntat fel ({{error}})', { error }),
  );

  NotificationManager.error(message, t('notification.error.unexpected.title', 'Misslyckat'));
  Sentry.captureException(error);
}
